import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCryptopunk: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCryptopunk"><Path fillRule="evenodd" clipRule="evenodd" d="M7 2H17V4H7V2ZM7 6V4H5V9H3V15H5V22H12V20H17V18H19V8H22V6H19V4H17V6H7ZM11 15V16H15V14H11.01V13H9V15H11ZM10 9H12.01V11H10V9ZM14 9H16.01V11H14V9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCryptopunk;
